import React, { useEffect, useRef, useState } from "react";
import config from "../../config";
import { triggerNotification } from "../../component/message/Msg";
import Swal from "sweetalert2";
import Breadcrumb from "../../component/breadcrumb/Breadcrumb";
import { useNavigate } from "react-router-dom";
import Spinner from "../../component/loadingbar/Spinner";
import Export from "../../component/Export";
import TableViewer from "../../component/tableViewer/TableViewer";
import noImg from "../../assetsCon/assets/images/noImg.png";

const TeacherForApproval = () => {
  const [teachers, setTeachers] = useState([]);
  const [loading, setLoading] = useState(false);
  const token = config.token;
  const navigate = useNavigate();

  //  ------For TableViewer ------
  const teachersRef = useRef([]);
  teachersRef.current = teachers;
  const [rowData, setRowData] = useState([]);
  //  ------For TableViewer ------

  //----------------------------------------------- Export xlsx File ----------------------------------------------
  const handleExport = () =>
    teachers.map((teacher) => {
      return {
        First_name: teacher.fname,
        Last_name: teacher.lname,
        Email: teacher.email,
        Mobile_no: teacher.mobileno,
        Address: teacher.address,
        Image: teacher.image,
        Gender: teacher.gender,
        DOB: teacher.dob,
      };
    });

  //----------------------------------------------- select / view teachers table  -------------------------------------------------R
  // Fetch all teachers
  const fetchTeachers = async () => {
    setLoading(true);
    try {
      await fetch(`${config.host_url}teacher`, {
        method: "GET",
        headers: {
          token: token,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.status === 200) {
            // Successful response, update the teachers state

            //  ------For TableViewer ------
            const notApprovedTeachers = data.data.filter(
              (teacher) => teacher.isApproved === 0
            );
            setTeachers(notApprovedTeachers);
            const teachersData = notApprovedTeachers.map((teacher) => ({
              teacher: teacher.fname + " " + teacher.lname,
              email: teacher.email,
              image: teacher?.image !== null ? teacher.image : noImg,
              mobile: teacher.mobileno,
              idNumber: teacher.tid,
            }));
            setRowData(teachersData);
            //  ------For TableViewer ------
          } else if (data.status === 401) {
            // Invalid token
            triggerNotification("error", "Unauthenticated user");
          } else {
            // Handle other errors
            triggerNotification(
              "error",
              "Internal server error, Please try after some time!!"
            );
          }
        });
    } catch (error) {
      triggerNotification("error", "Error fetching teachers.");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchTeachers();
  }, [token]);

  // ---------------------------------------------------- Delete Teacher ---------------------------------------------------------D
  // Show a confirmation dialog
  const btnDeleteHandle = (deleteId, i) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You are about to delete Teacher. Are you sure you want to proceed?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        handleDeleteTeacher(deleteId, i);
      }
    });
  };

  //If confirm then delete Teacher
  const handleDeleteTeacher = async (deleteId, i) => {
    try {
      await fetch(`${config.host_url}teacher/${deleteId}`, {
        method: "DELETE",
        headers: {
          token: token,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.status === 200) {
            triggerNotification("success", "Teacher deleted successfully.");

            //  ------For TableViewer ------
            const updatedTeachers = [...teachersRef.current];
            updatedTeachers.splice(i, 1);

            const notApprovedTeachers = updatedTeachers.filter(
              (teacher) => teacher.isApproved === 0
            );
            setTeachers(notApprovedTeachers);
            const teachersData = notApprovedTeachers.map((teacher) => ({
              teacher: teacher.fname + " " + teacher.lname,
              email: teacher.email,
              image: teacher?.image !== null ? teacher.image : noImg,
              mobile: teacher.mobileno,
              idNumber: teacher.tid,
            }));
            setRowData(teachersData);
            //  ------For TableViewer ------
          } else if (data.status === 401) {
            // Invalid Token
            triggerNotification("error", "Unauthenticated User");
          } else {
            // Internal Server Error or other HTTP errors
            triggerNotification(
              "error",
              "Internal server error, Please try after some time!"
            );
          }
        });
    } catch (error) {
      triggerNotification("error", "Error deleting teacher");
    }
  };

  //----------------------------------------------- select / view teachers table  -------------------------------------------------R
  const btnShowHandle = (id) => {
    const encodedId = window.btoa(encodeURIComponent(id));
    navigate(`/viewteacher/${encodedId}/aprvl`);
  };

  //----------------------------------------------- update / edit teachers table  -------------------------------------------------R
  const btnEditHandle = (id) => {
    const encodedId = window.btoa(encodeURIComponent(id));
    navigate(`/addteacher/${encodedId}/aprvl`);
  };

  //----------------------------------------------- enable - disable teacher -----------------------------------------------
  const enabledisableTeacherBtn = (tid, i) => {
    Swal.fire({
      title: "Are you sure?",
      text: `You are about to approve teacher?. Are you sure you want to proceed?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: `Yes, approve it!`,
    }).then((result) => {
      if (result.isConfirmed) {
        enabledisableTeacher();
      }
    });

    //If confirm then enable/ disable teacher
    const enabledisableTeacher = async () => {
      try {
        await fetch(`${config.host_url}teacher/approved/${tid}/1`, {
          method: "GET",
          headers: {
            token: token,
          },
        })
          .then((response) => response.json())
          .then(function (data) {
            if (data.status === 200) {
              triggerNotification("success", `Teacher approved successfully`);
              //  ------For TableViewer ------
              const updatedTeachers = [...teachersRef.current];
              updatedTeachers.splice(i, 1);

              setTeachers(updatedTeachers);
              const teachersData = updatedTeachers.map((teacher) => ({
                teacher: teacher.fname + " " + teacher.lname,
                email: teacher.email,
                image: teacher?.image !== null ? teacher.image : noImg,
                mobile: teacher.mobileno,
                idNumber: teacher.tid,
              }));
              setRowData(teachersData);
              //  ------For TableViewer ------
            } else if (data.status === 404) {
              // teacher IDs Not Found
              console.error("Teacher ID is not found");
              triggerNotification("error", "Teacher ID is not found");
            } else if (data.status === 401) {
              // Invalid Token
              console.error("Invalid token");
              triggerNotification("error", "Unauthenticated User");
            } else {
              // Internal Server Error or other HTTP errors
              console.error("Internal server error");
              triggerNotification(
                "error",
                "Internal server error, Please try after some time!"
              );
            }
          });
      } catch (error) {
        console.error("Error enabling teacher", error);
        triggerNotification("error", "Error enabling teacher");
      }
    };
  };

  //  ------For TableViewer ------
  const colDefs = [
    {
      headerName: "#",
      width: 50,
      valueFormatter: (params) => {
        return `${parseInt(params.node.id) + 1}`;
      },
    },
    {
      headerName: "Teacher",
      field: "teacher",
      width: 300,
      cellRenderer: (params) => (
        <div className=" flex py-1 ">
          <img
            src={params.data.image}
            alt="Teacher_Image"
            className="rounded h-11 w-11  bg-gray-300 mr-4"
          />
          <p className="p-0 m-0">{params.data.teacher}</p>
        </div>
      ),
    },
    // { field: "teacher", filter: true },
    { field: "email", filter: true, width: 250 },
    { field: "mobile", filter: true },
  ];
  //  ------For TableViewer ------

  return (
    <>
      <Breadcrumb txt="Manage Teacher" subpath={["Teacher For Approval"]} />
      <div className="col-xxl">
        <div className="card mb-4">
          <div className="card-header d-flex align-items-center row flex justify-between">
            <h5 className="mb-0 col-sm-3">Teacher For Approval</h5>
            <div className="col-sm-3 flex justify-end mt-2">
              <Export onExport={handleExport} teacher />
              <button
                type="button"
                className="btn btn-primary ml-4"
                onClick={() => {
                  navigate("/addteacher");
                }}
              >
                Add Teacher
              </button>
            </div>
          </div>
          {loading ? (
            <Spinner />
          ) : (
            <div className="px-3 pb-3  table-responsive">
              {/* ------For TableViewer ------ */}
              <TableViewer
                rowData={rowData}
                colDefs={colDefs}
                onEdit={btnEditHandle}
                onDelete={btnDeleteHandle}
                onView={btnShowHandle}
                onEnable={enabledisableTeacherBtn}
                // haveImage
              />
              {/* ------For TableViewer ------ */}
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default TeacherForApproval;
